'use client';

import { c as _c } from "react/compiler-runtime";
import { type Intention, updateCouponBoard } from '@svenskaspelab/poolbetting/core/frameworks/actions/coupon';
import { useCouponId } from '@svenskaspelab/poolbetting/core/nextjs/coupon';
import type { Outcome } from '@svenskaspelab/poolbetting/schema/coupon';
import type { EventNumber } from '@svenskaspelab/poolbetting/schema/sport';
import { useMediaQueryBelow } from '@svenskaspelab/ui/react/media-query';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { type ReactNode, useCallback } from 'react';
import type { AnalyzeDetails } from './GameAnalysis';
import GameAnalysisCopyToBoard from './GameAnalysisCopyToBoard';

/**
 * Renders the client-side buttons (copy to board) for an author's game analysis.
 *
 * @param root0 - The props object
 * @param root0.authorLongName - The author's long name of the current game analysis.
 * @param root0.selectedOutcomes - The selected outcomes from the game analysis.
 * @returns The GameAnalysisCopyToBoard component.
 */
function GameAnalysisCopyToBoardContainer(t0) {
  const $ = _c(11);
  const {
    authorLongName,
    selectedOutcomes
  } = t0;
  const [couponId, couponIndex] = useCouponId();
  const isSmallScreen = useMediaQueryBelow("lg");
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex || $[2] !== isSmallScreen || $[3] !== pathname || $[4] !== router || $[5] !== searchParams || $[6] !== selectedOutcomes) {
    t1 = async event => {
      event.preventDefault();
      const outcomes = {
        values: [],
        intention: "reset"
      };
      if (selectedOutcomes) {
        for (const outcome of selectedOutcomes) {
          outcomes.values.push({
            group: 0,
            event: outcome.eventNumber,
            outcomes: outcome.outcomes ?? []
          });
        }
      }
      await updateCouponBoard({
        outcomes
      }, {
        couponId,
        couponIndex,
        boardIndex: 0
      });
      if (isSmallScreen) {
        const params = new URLSearchParams(searchParams.toString());
        params.delete("modal");
        router.push(`${pathname}?${params.toString()}`);
      }
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = isSmallScreen;
    $[3] = pathname;
    $[4] = router;
    $[5] = searchParams;
    $[6] = selectedOutcomes;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleSubmit = t1;
  let t2;
  if ($[8] !== authorLongName || $[9] !== handleSubmit) {
    t2 = <GameAnalysisCopyToBoard authorLongName={authorLongName} handleSubmit={handleSubmit} />;
    $[8] = authorLongName;
    $[9] = handleSubmit;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
export default GameAnalysisCopyToBoardContainer;